"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePositiveNumber = void 0;
function validatePositiveNumber(value, property) {
    const errors = [];
    if (value === null || value === undefined) {
        errors.push(`${property} is missing`);
    }
    if (value <= 0) {
        errors.push(`${property} must be greater than 0 but was ${value}`);
    }
    return errors;
}
exports.validatePositiveNumber = validatePositiveNumber;
//# sourceMappingURL=validate-positive-number.js.map